import store from '@/stores/store';
import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import $utils from '@/utils';
import billingaccounts from './submodules/billingaccounts';
import catalogs from './submodules/catalogs';
import stocks from './submodules/stocks';

const state = {
    customer: null,
    customer_saving: false,
    customer_saving_errors: {},

    allowed_stocks: [],
    allowed_catalogs: [],

    delivery_address_same_as_billing: true,
};

const mutations = {
    updateCustomer(state, customer) {
        state.customer = customer;
    },
    updateCustomerSaving(state, saving) {
        state.customer_saving = saving;
    },
    updateCustomerSavingErrors(state, errors) {
        state.customer_saving_errors = errors;
    },
    updateBillingAccount(state, billingaccount) {
        state.customer.billingaccount = billingaccount?.id;
        state.customer.billingaccount_data = billingaccount;
    },
    updateBillingAccountLoading(state, loading) {
        state.billingaccount_loading = loading;
    },
    setDefaultStock(state, stocks) {
        if (!state.customer?.id) {
            const main_stock = stocks.find((item) => item.main)
            if (main_stock) {
                state.allowed_stocks = [main_stock.id];
            } else {
                state.allowed_stocks = [];
            }
        } else {
            state.allowed_stocks = state.stocks.stocks.filter((item) => item.allowed).map((item) => item.id);
        }
    },
    setDefaultCatalog(state, catalogs) {
        if (!state.customer.id) {
            const maincatalog = catalogs.find((item) => item.default && item.owner == store.getters["session/current_entity_id"]);
            if (maincatalog) {
                state.allowed_catalogs = [maincatalog.id];
            } else {
                state.allowed_catalogs = [];
            }
        } else {
            state.allowed_catalogs = catalogs.filter((item) => item.allowed).map((item) => item.id);
        }
    },
    updateAllowedStocks(state, stocks) {
        state.allowed_stocks = stocks;
    },
    updateAllowedCatalogs(state, catalogs) {
        state.allowed_catalogs = catalogs;
    },
    updateDeliveryAddressSameAsBilling(state, same_as_billing) {
        state.delivery_address_same_as_billing = same_as_billing;
    },

    updateBillingAddress(state, billing_address) {
        state.customer = { ...state.customer, billing_address,};
    },
};

const actions = {

    async saveCustomer({ commit, dispatch, state }) {
        commit('updateCustomerSaving', true);
        let url = '/api/customers/';
        let method = axios.post;
        if (state.customer.id) {
            url = `/api/customers/${state.customer.id}/`;
            method = axios.put;
        }
        let customer = { ...state.customer, catalogs: state.allowed_catalogs, allowed_stocks: state.allowed_stocks };
        if (state.delivery_address_same_as_billing) {
            customer.delivery_address = customer.billing_address;
        }
        delete customer.debit_iban_masked;
        delete customer.preferred_payment_method_changed_at;

        try {
            const response = await method(url, customer);
            commit('updateCustomerSaving', false);
            dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateCustomerSavingErrors', error.details);
            commit('updateCustomerSaving', false);
            throw error;
        }
    },


    changeBillingAccountId({ state, commit }, billingaccount_id) {
        commit('updateBillingAccount', state.billingaccounts.billingaccounts.find((item) => item.id == billingaccount_id));
    },

    async prefillBillingFromDeliverySites({ commit, state }) {
        const billing = state.customer?.billing_address;
        if (!$utils.isAddressEmpty(billing) || !state.customer?.id) {
            return;
        }
        try {
            const response = await axios.get(
                `/api/customers/${state.customer.id}/deliverysites/`,
                { params: { limit: 50, archived: false } }
            );
            const siteAddress = $utils.pickDeliverySiteAddress(
                response.data.results
            );
            if (!siteAddress) {
                return;
            }
            const street = { ...siteAddress };
            delete street.id;
            delete street.creation_date;
            commit("updateBillingAddress", {
                ...(billing || {}),
                ...street,
                id: billing?.id,
                emails: billing?.emails?.length
                    ? billing.emails
                    : street.emails || [],
            });
        } catch (error) {
            // Optional prefill: a missing permission must not block the form.
        }
    },

    async init({ commit, dispatch, state }, params) {
        await commit('updateCustomerSavingErrors', {});
        await commit('updateCustomer', params.customer);
        await commit('updateDeliveryAddressSameAsBilling', true);
        await dispatch('prefillBillingFromDeliverySites');
        await dispatch('billingaccounts/fetchBillingAccounts');
        if (state.customer?.id) {
            await dispatch('activebillingaccounts/init', {
                filters: { customer: state.customer.id },
            });
        }

        if (
            store.getters["session/current_user_mode"] == "operator" &&
            state.customer?.id
        ) {
            await dispatch('stocks/init', {
                filters: { customerstock_customer: state.customer.id }
            });
            let stocks = await dispatch('stocks/fetchStocks')
            commit('setDefaultStock', stocks?.results);

            await dispatch('catalogs/init', {
                filters: { limit: 1000, assignment_customer: state.customer.id, ordering: 'owner_name', type: 'sell' },
            });
            let catalogs = await dispatch('catalogs/fetchCatalogs');
            commit('setDefaultCatalog', catalogs?.results);
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        catalogs: catalogs(),
        stocks: stocks(),
        billingaccounts: billingaccounts(),
        activebillingaccounts: billingaccounts(),
    }
};